// Central catalogue of every editable page image slot + its default (fallback) URL.
// Shared by the admin Page Media manager and the usePageMedia hook so the two
// never drift apart. Adding a new slot here automatically makes it editable.

export const PAGE_MEDIA = {
  home: {
    label: 'Homepage',
    slots: [
      { key: 'hero', label: 'Hero background', aspect: '16:9', recommended: '1920×1080 · JPG · ≤ 250 KB' },
      { key: 'category_sim_pcs', label: 'Category card — Sim Rig PCs', aspect: '4:3', recommended: '800×600 · JPG · ≤ 100 KB' },
      { key: 'category_brackets', label: 'Category card — Sim Rig Brackets', aspect: '4:3', recommended: '800×600 · JPG · ≤ 100 KB' },
      { key: 'category_bookings', label: 'Category card — Sim Rig Bookings', aspect: '4:3', recommended: '800×600 · JPG · ≤ 100 KB' },
      { key: 'category_gift_cards', label: 'Category card — Gift Cards', aspect: '4:3', recommended: '800×600 · JPG · ≤ 100 KB' },
      { key: 'about', label: 'About / Story image', aspect: '4:3', recommended: '800×600 · JPG · ≤ 150 KB' },
      { key: 'promo_shop', label: 'Promo split — Shop', aspect: '16:10', recommended: '800×500 · JPG · ≤ 120 KB' },
      { key: 'promo_bookings', label: 'Promo split — Bookings', aspect: '16:10', recommended: '800×500 · JPG · ≤ 120 KB' },
    ],
  },
  shop: {
    label: 'Shop',
    slots: [
      { key: 'hero', label: 'Header background (optional)', aspect: '16:6', recommended: '1920×720 · JPG · ≤ 200 KB' },
    ],
  },
  bookings: {
    label: 'Bookings',
    slots: [
      { key: 'hero', label: 'Header background (optional)', aspect: '16:6', recommended: '1920×720 · JPG · ≤ 200 KB' },
    ],
  },
  simulators: {
    label: 'Simulators',
    slots: [
      { key: 'hero', label: 'Header background (optional)', aspect: '16:6', recommended: '1920×720 · JPG · ≤ 200 KB' },
    ],
  },
  about: {
    label: 'About',
    slots: [
      { key: 'hero', label: 'Header background (optional)', aspect: '16:6', recommended: '1920×720 · JPG · ≤ 200 KB' },
    ],
  },
  contact: {
    label: 'Contact',
    slots: [
      { key: 'hero', label: 'Header background (optional)', aspect: '16:6', recommended: '1920×720 · JPG · ≤ 200 KB' },
    ],
  },
  parties: {
    label: 'Parties',
    slots: [
      { key: 'hero', label: 'Hero background', aspect: '16:9', recommended: '1920×1080 · JPG · ≤ 250 KB' },
    ],
  },
  corporate: {
    label: 'Corporate',
    slots: [
      { key: 'hero', label: 'Hero image (split-screen)', aspect: '4:5', recommended: '1200×1500 · JPG · ≤ 250 KB' },
      { key: 'brochure_pdf', label: 'Corporate Brochure PDF', kind: 'pdf', recommended: 'PDF · ≤ 5 MB' },
    ],
  },
};

export const PAGE_MEDIA_DEFAULTS = {
  home: {
    hero: 'https://media.base44.com/images/public/69e75b1fdf3eee5e6d1453dc/de63d0e06_generated_66d7d18e.png',
    category_sim_pcs: 'https://media.base44.com/images/public/69e75b1fdf3eee5e6d1453dc/360bd41d0_generated_bea79009.png',
    category_brackets: 'https://media.base44.com/images/public/69e7659143303e8153678f84/346d9c7e8_generated_image.png',
    category_bookings: 'https://media.base44.com/images/public/69e75b1fdf3eee5e6d1453dc/6fbe60b23_generated_b6361651.png',
    category_gift_cards: 'https://media.base44.com/images/public/69e7659143303e8153678f84/c2349926e_44ea0cb0-d900-43e4-a955-cea61d43fd73.jpg',
    about: 'https://media.base44.com/images/public/69e75b1fdf3eee5e6d1453dc/e7d787c0c_generated_c0922e1e.png',
    promo_shop: 'https://media.base44.com/images/public/69e75b1fdf3eee5e6d1453dc/360bd41d0_generated_bea79009.png',
    promo_bookings: 'https://media.base44.com/images/public/69e75b1fdf3eee5e6d1453dc/6fbe60b23_generated_b6361651.png',
  },
  parties: {
    hero: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=1920&q=80&auto=format&fit=crop',
  },
  corporate: {
    hero: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80&auto=format&fit=crop',
    brochure_pdf: '',
  },
};